import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CreateManufacturerDialogContentComponent } from './create-manufacturer-dialog-content/create-manufacturer-dialog-content.component';

@Component({
  selector: 'app-create-manufacturer-dialog',
  template: ''
})
export class CreateManufacturerDialogComponent implements OnInit {

  constructor(public dialog: NgbModal, private router: Router, private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.openDialog();
  }

  openDialog(): void {
    var customerId = this.activatedRoute.parent.parent.snapshot.params.key;

    const dialogRef = this.dialog.open(CreateManufacturerDialogContentComponent, { centered: true, backdrop: 'static' });

    dialogRef.componentInstance.customerId = customerId;

    dialogRef.result.then((result) => {
      this.router.navigate(['../'], { relativeTo: this.activatedRoute });
    }, (backdrop) => {
      this.router.navigate(['../'], { relativeTo: this.activatedRoute });
    });
  }

}
